import { render } from "./redirect-view.vue?vue&type=template&id=cf5bd530"
import script from "./redirect-view.vue?vue&type=script&lang=js"
export * from "./redirect-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__